export const dashboardRoles = {
	agent: { level: 4, name: "Agent" },
	master: { level: 3, name: "Master" },
	stockist: { level: 2, name: "Stokist" },
	"super-stockist": { level: 1, name: "Super Stokist" },
};

export const getDashboardRole = (pathname) => {
	const pathSegments = pathname.split("/").filter(Boolean);
	const rolePath = pathSegments[0];
	return dashboardRoles[rolePath] ? { path: rolePath, ...dashboardRoles[rolePath] } : null;
};
